import { number as l, string as o, union as a, boolean as q, literal as u, object as e, enum as h, never as w } from "../../node_modules/zod/v4/classic/schemas.js";
const t = l(), p = o().regex(/^-?\d+(\.\d+)?$/).transform((i) => parseFloat(i)), c = a([
  q(),
  u("true").transform(() => !0),
  u("false").transform(() => !1),
  u(1).transform(() => !0),
  u(0).transform(() => !1)
]), n = a([
  e({
    x: l(),
    y: l(),
    z: l()
  }),
  t.transform((i) => ({ x: i, y: i, z: i })),
  p.transform((i) => ({ x: i, y: i, z: i })),
  o().regex(/^-?\d+(\.\d+)?\s+-?\d+(\.\d+)?\s+-?\d+(\.\d+)?$/).transform((i) => {
    const [b, g, z] = i.split(/\s+/).map(Number);
    return { x: b, y: g, z };
  })
]);
a([
  e({
    x: l(),
    y: l()
  }),
  t.transform((i) => ({ x: i, y: i })),
  p.transform((i) => ({ x: i, y: i })),
  o().regex(/^-?\d+(\.\d+)?\s+-?\d+(\.\d+)?$/).transform((i) => {
    const [b, g] = i.split(/\s+/).map(Number);
    return { x: b, y: g };
  })
]);
const r = a([
  o().regex(/^#[0-9a-fA-F]{6}$/).transform((i) => parseInt(i.slice(1), 16)),
  o().regex(/^0x[0-9a-fA-F]{6}$/).transform((i) => parseInt(i.slice(2), 16)),
  t,
  p
]), s = h(["box", "sphere"]), k = h(["static", "dynamic", "kinematic"]), m = e({
  pos: n.optional(),
  scale: n.optional(),
  euler: n.optional(),
  rot: w().optional()
}).strict(), f = e({
  type: k.optional(),
  pos: n.optional(),
  euler: n.optional(),
  mass: t.optional(),
  "linear-damping": t.optional(),
  "angular-damping": t.optional(),
  "gravity-scale": t.optional()
}).strict(), d = e({
  shape: s.optional(),
  size: n.optional(),
  restitution: t.optional(),
  friction: t.optional(),
  density: t.optional(),
  sensor: c.optional()
}).strict(), y = e({
  shape: s.optional(),
  size: n.optional(),
  color: r.optional(),
  "cast-shadow": c.optional(),
  "receive-shadow": c.optional(),
  visible: c.optional()
}).strict(), S = e({
  distance: t.optional(),
  "min-distance": t.optional(),
  "max-distance": t.optional(),
  "min-pitch": t.optional(),
  "max-pitch": t.optional(),
  "target-pitch": t.optional(),
  "target-yaw": t.optional(),
  sensitivity: t.optional(),
  smoothing: t.optional(),
  enabled: c.optional()
}).strict(), x = e({
  speed: t.optional(),
  "jump-height": t.optional(),
  acceleration: t.optional(),
  "air-control": t.optional(),
  enabled: c.optional()
}).strict(), C = e({
  transform: a([o(), m]).optional(),
  body: a([o(), f]).optional(),
  collider: a([o(), d]).optional(),
  renderer: a([o(), y]).optional(),
  "orbit-camera": a([o(), S]).optional(),
  player: a([o(), x]).optional(),
  pos: n.optional(),
  scale: n.optional(),
  euler: n.optional(),
  color: r.optional(),
  size: n.optional(),
  shape: s.optional(),
  id: o().optional()
}).passthrough(), R = e({
  pos: n,
  shape: s,
  size: n,
  color: r,
  transform: a([o(), m]).optional(),
  collider: a([o(), d]).optional(),
  renderer: a([o(), y]).optional(),
  scale: n.optional(),
  euler: n.optional(),
  restitution: t.optional(),
  friction: t.optional(),
  id: o().optional(),
  name: o().optional()
}).strict(), $ = e({
  pos: n,
  shape: s,
  size: n,
  color: r,
  transform: a([o(), m]).optional(),
  body: a([o(), f]).optional(),
  collider: a([o(), d]).optional(),
  renderer: a([o(), y]).optional(),
  scale: n.optional(),
  euler: n.optional(),
  mass: t.optional(),
  restitution: t.optional(),
  friction: t.optional(),
  id: o().optional(),
  name: o().optional()
}).strict(), j = e({
  pos: n,
  shape: s,
  size: n,
  color: r,
  transform: a([o(), m]).optional(),
  body: a([o(), f]).optional(),
  collider: a([o(), d]).optional(),
  renderer: a([o(), y]).optional(),
  scale: n.optional(),
  euler: n.optional(),
  id: o().optional(),
  name: o().optional()
}).strict(), E = e({
  pos: n.optional(),
  speed: t.optional(),
  "jump-height": t.optional(),
  acceleration: t.optional(),
  "air-control": t.optional(),
  transform: a([o(), m]).optional(),
  body: a([o(), f]).optional(),
  collider: a([o(), d]).optional(),
  player: a([o(), x]).optional(),
  id: o().optional()
}).strict(), F = e({
  distance: t.optional(),
  "min-distance": t.optional(),
  "max-distance": t.optional(),
  "target-pitch": t.optional(),
  "target-yaw": t.optional(),
  transform: a([o(), m]).optional(),
  "orbit-camera": a([o(), S]).optional(),
  id: o().optional()
}).strict(), P = e({
  canvas: o().optional(),
  sky: r.optional(),
  fog: r.optional(),
  "fog-near": t.optional(),
  "fog-far": t.optional(),
  gravity: n.optional(),
  id: o().optional()
}).strict(), v = h([
  "linear",
  "ease",
  "ease-in",
  "ease-out",
  "ease-in-out",
  "sine-in",
  "sine-out",
  "sine-in-out",
  "quad-in",
  "quad-out",
  "quad-in-out",
  "cubic-in",
  "cubic-out",
  "cubic-in-out",
  "quart-in",
  "quart-out",
  "quart-in-out",
  "expo-in",
  "expo-out",
  "expo-in-out",
  "circ-in",
  "circ-out",
  "circ-in-out",
  "back-in",
  "back-out",
  "back-in-out",
  "elastic-in",
  "elastic-out",
  "elastic-in-out",
  "bounce-in",
  "bounce-out",
  "bounce-in-out"
]);
h(["once", "loop", "ping-pong"]);
const A = e({
  target: o(),
  attr: o(),
  from: a([t, p, n]).optional(),
  to: a([t, p, n]),
  duration: a([t, p]).default(1),
  delay: a([t, p]).optional(),
  easing: v.optional(),
  id: o().optional(),
  name: o().optional()
}).strict(), I = e({
  duration: a([t, p]).default(0)
}).strict(), N = e({
  id: o().optional(),
  name: o().optional()
}).strict(), _ = {
  entity: C,
  "static-part": R,
  "dynamic-part": $,
  "kinematic-part": j,
  player: E,
  camera: F,
  world: P,
  tween: A,
  pause: I,
  sequence: N
};
export {
  f as bodyComponentSchema,
  k as bodyTypeSchema,
  F as cameraRecipeSchema,
  d as colliderComponentSchema,
  r as colorSchema,
  $ as dynamicPartRecipeSchema,
  v as easingSchema,
  C as entityRecipeSchema,
  j as kinematicPartRecipeSchema,
  S as orbitCameraComponentSchema,
  I as pauseElementSchema,
  x as playerComponentSchema,
  E as playerRecipeSchema,
  _ as recipeSchemas,
  y as rendererComponentSchema,
  N as sequenceElementSchema,
  s as shapeSchema,
  R as staticPartRecipeSchema,
  m as transformComponentSchema,
  A as tweenElementSchema,
  n as vector3Schema,
  P as worldRecipeSchema
};
//# sourceMappingURL=schemas.js.map
